import type { FC } from 'react';

import Head from 'next/head';
import { useMemo } from 'react';

import { SiteType } from '~/utilities/graphql/codegen';

const AVAILABLE_FAVICONS = [SiteType.Gstar, SiteType.Aaf, SiteType.Wahts];

export const Favicons: FC<{ siteType: SiteType }> = ({ siteType }) => {
  const folderPath = useMemo(
    () => (AVAILABLE_FAVICONS.includes(siteType) ? siteType : SiteType.Gstar),
    [siteType]
  );

  return (
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="manifest" href={`/_fes/${folderPath}/manifest.json`} />
      <link rel="icon" type="image/svg+xml" href={`/_fes/${folderPath}/favicons/favicon.svg`} />
      <link
        rel="icon"
        type="image/png"
        href={`/_fes/${folderPath}/favicons/favicon-32x32.png`}
        sizes="32x32"
      />
      <link
        rel="icon"
        type="image/png"
        href={`/_fes/${folderPath}/favicons/favicon-16x16.png`}
        sizes="16x16"
      />
      <link
        rel="icon"
        type="image/png"
        href={`/_fes/${folderPath}/favicons/favicon-192x192.png`}
        sizes="192x192"
      />
      <link rel="icon" type="image/x-icon" href={`/_fes/${folderPath}/favicon.ico`} />
      <link rel="apple-touch-icon" href={`/_fes/${folderPath}/favicons/apple-touch-icon.png`} />
      <link
        rel="mask-icon"
        href={`/_fes/${folderPath}/favicons/safari-pinned-tab.svg`}
        color="#303030"
      />
    </Head>
  );
};
